import { render } from "./FuelYourBussiness.vue?vue&type=template&id=2996df7d&scoped=true"
import script from "./FuelYourBussiness.vue?vue&type=script&lang=js"
export * from "./FuelYourBussiness.vue?vue&type=script&lang=js"

import "./FuelYourBussiness.vue?vue&type=style&index=0&id=2996df7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2996df7d"]])

export default __exports__